<template>
    <form class="change-password" v-bind:action="apiUrl + '/users/' + this.user.id" v-on:submit.prevent="handleSubmit">
        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.old_password }">
            <label class="form__label" for="password-old">{{ __('Old password') }}</label>
            <span class="jam jam-key is-large"></span>
            <input class="form__control is-large" id="password-old" type="password" autocomplete="off"
                   v-bind:placeholder="__('Old password')"
                   v-model="oldPassword"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.old_password">{{ errors.old_password[0] }}</small>

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.password }">
            <label class="form__label" for="password-new">{{ __('New password') }}</label>
            <span class="jam jam-padlock-open is-large"></span>
            <input class="form__control is-large" id="password-new" type="password" autocomplete="off"
                   v-bind:placeholder="__('New password')"
                   v-model="newPassword"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.password">{{ errors.password[0] }}</small>

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.confirm_password }">
            <label class="form__label" for="password-confirm">{{ __('Confirm password') }}</label>
            <span class="jam jam-padlock is-large"></span>
            <input class="form__control is-large" id="password-confirm" type="password" autocomplete="off"
                   v-bind:placeholder="__('Enter the same password')"
                   v-model="confirmPassword"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.confirm_password">{{ errors.confirm_password[0] }}</small>

        <button class="btn is-primary edit-profile__save-btn">{{ __('Change password') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                confirmPassword: '',
                errors: {},
                oldPassword: '',
                newPassword: ''
            }
        },
        methods: {
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');

                this.$http.patch(action, {
                    password: this.newPassword,
                    password_confirmation: this.confirmPassword,
                    old_password: this.oldPassword
                }).then(function (response) {
                    eventBus.$emit('show-alert', 'success', this.__('Your password has been updated successfully.'));
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ChangePassword.vue